/**
 * 运营端：将租户小程序码与协会名称等合成单张 PNG（风格对齐小程序「推广海报」：浅灰底、白卡片、标题 + 码 + 底部提示）。
 */

function fillRoundRect(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  w: number,
  h: number,
  r: number,
) {
  const rr = Math.min(r, w / 2, h / 2);
  ctx.beginPath();
  ctx.moveTo(x + rr, y);
  ctx.arcTo(x + w, y, x + w, y + h, rr);
  ctx.arcTo(x + w, y + h, x, y + h, rr);
  ctx.arcTo(x, y + h, x, y, rr);
  ctx.arcTo(x, y, x + w, y, rr);
  ctx.closePath();
}

function wrapLinesByWidth(
  ctx: CanvasRenderingContext2D,
  text: string,
  maxWidth: number,
  maxLines: number,
): string[] {
  const t = String(text || "").trim() || "球迷协会";
  const lines: string[] = [];
  let i = 0;
  while (i < t.length && lines.length < maxLines) {
    let end = i + 1;
    while (end <= t.length && ctx.measureText(t.slice(i, end)).width <= maxWidth) end += 1;
    end -= 1;
    if (end <= i) end = i + 1;
    lines.push(t.slice(i, end));
    i = end;
  }
  if (i < t.length && lines.length > 0) {
    const last = lines[lines.length - 1]!;
    lines[lines.length - 1] = last.length > 0 ? `${last.slice(0, -1)}…` : "…";
  }
  return lines.slice(0, maxLines);
}

export async function createTenantWeappPosterDataUrl(qrUrl: string, tenantName: string): Promise<string> {
  const qr = String(qrUrl || "").trim();
  if (!qr) throw new Error("缺少小程序码地址");

  const res = await fetch(qr, { mode: "cors" });
  if (!res.ok) throw new Error(`小程序码加载失败（${res.status}）`);
  const blob = await res.blob();
  const bmp = await createImageBitmap(blob);

  const cssW = 600;
  const cssH = 960;
  const canvas = document.createElement("canvas");
  canvas.width = cssW;
  canvas.height = cssH;
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    bmp.close();
    throw new Error("Canvas 不可用");
  }

  ctx.fillStyle = "#f8fafc";
  ctx.fillRect(0, 0, cssW, cssH);

  const cardX = 28;
  const cardY = 44;
  const cardW = cssW - 56;
  const cardH = cssH - 88;
  ctx.fillStyle = "#ffffff";
  fillRoundRect(ctx, cardX, cardY, cardW, cardH, 18);
  ctx.fill();
  ctx.strokeStyle = "#e5e7eb";
  ctx.lineWidth = 2;
  fillRoundRect(ctx, cardX, cardY, cardW, cardH, 18);
  ctx.stroke();

  const title = String(tenantName || "").trim() || "球迷协会";
  ctx.fillStyle = "#111827";
  ctx.font = "bold 22px system-ui, -apple-system, Segoe UI, sans-serif";
  ctx.textAlign = "center";
  ctx.textBaseline = "top";
  const maxTitleW = cardW - 40;
  const titleLines = wrapLinesByWidth(ctx, title, maxTitleW, 3);
  let ty = cardY + 26;
  for (const line of titleLines) {
    ctx.fillText(line, cssW / 2, ty);
    ty += 30;
  }

  ctx.fillStyle = "#9ca3af";
  ctx.font = "13px system-ui, -apple-system, Segoe UI, sans-serif";
  ctx.fillText("微信扫码进入小程序", cssW / 2, ty + 6);

  const titleBlockEnd = ty + 6 + 20;
  const hintY = cardY + cardH - 26;
  let qrSize = 280;
  let qy = Math.floor(hintY - 10 - qrSize);
  if (qy < titleBlockEnd + 16) {
    qy = titleBlockEnd + 16;
    qrSize = Math.floor(Math.max(200, hintY - 10 - qy));
  }
  const qx = Math.floor(cssW / 2 - qrSize / 2);
  ctx.drawImage(bmp, qx, qy, qrSize, qrSize);
  bmp.close();

  ctx.fillStyle = "#6b7280";
  ctx.font = "12px system-ui, -apple-system, Segoe UI, sans-serif";
  ctx.textAlign = "center";
  ctx.textBaseline = "top";
  ctx.fillText("长按识别小程序码 · 微信扫一扫", cssW / 2, hintY);

  return canvas.toDataURL("image/png");
}

export async function dataUrlToBlob(dataUrl: string): Promise<Blob> {
  const r = await fetch(dataUrl);
  return r.blob();
}
